import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-PKMER3TWDR', {
        page_path: location.pathname,
      });
      console.log('Pageview enviado para GA4:', location.pathname);
    }
  }, [location]);
};

export default usePageView;
